// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/order-styles.css'
import './styles/MarqueeText.css'
import './styles/ReviewForm.css'
import './styles/PWAInstallBanner.css'
import './styles/BrowserInstructionModal.css'
import './styles/WelcomeDialog.css'
import './styles/support.css'
import './styles/Wishlist.css'
import './styles/new-styles.css'
import './styles/ReviewsSection.css'
import './styles/search.css';
import './styles/ResetPasswordModal.css';
import './styles/AuthCallback.css';
import './styles/./cartItem.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";

window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    console.error('🔴 Unhandled Promise Rejection:', {
        message: reason?.message,
        code: reason?.code,
        details: reason?.details,
        hint: reason?.hint,
        full: JSON.stringify(reason, null, 2)
    });
});

window.onerror = (msg, src, line, col, error) => {
    console.error('🔴 Global error:', { msg, src, line, col, error });
};

// Регистрация Service Worker
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
                console.log('SW registered: ', registration);
            })
            .catch(error => {
                console.log('SW registration failed: ', error);
            });
    });
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

// Убираем StrictMode для избежания двойного рендера
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

reportWebVitals();